@if (toastService.message(); as message) {
  <div class="toast" role="status" aria-live="polite">{{ message }}</div>
}
